// Card validation utility
export const validateCard = (card) => {
  const errors = [];
  
  // Basic existence check
  if (!card) {
    return { isValid: false, errors: ['Card data is missing'] };
  }
  
  // Check for required/expected fields
  if (typeof card !== 'object') {
    errors.push('Card must be an object');
  }
  
  // Validate blocks array if present
  if (card.blocks) {
    if (!Array.isArray(card.blocks)) {
      errors.push('Card blocks must be an array');
    } else {
      card.blocks.forEach((block, index) => {
        if (!block) {
          errors.push(`Block at index ${index} is null/undefined`);
        } else if (typeof block !== 'object') {
          errors.push(`Block at index ${index} must be an object`);
        } else if (!block.kind && !block.type) {
          errors.push(`Block at index ${index} is missing 'kind' or 'type' field`);
        }
      });
    }
  }
  
  // Validate collapse_settings if present
  if (card.collapse_settings && typeof card.collapse_settings !== 'object') {
    errors.push('collapse_settings must be an object');
  }
  
  // Validate block_layout if present
  if (card.block_layout && !['row', 'column', 'stacked', 'grid'].includes(card.block_layout)) {
    errors.push(`Invalid block_layout: ${card.block_layout}. Must be one of: row, column, stacked, grid`);
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// Block validation utility
export const validateBlock = (block) => {
  const errors = [];
  
  if (!block) {
    return { isValid: false, errors: ['Block data is missing'] };
  }
  
  if (typeof block !== 'object') {
    return { isValid: false, errors: ['Block must be an object'] };
  }
  
  // Check for block type/kind
  const blockType = block.type || block.kind;
  if (!blockType) {
    errors.push('Block is missing required "type" or "kind" field');
  }
  
  // Validate specific block types
  switch (blockType) {
    case 'details_grid':
      if (typeof block.columns !== 'number') {
        errors.push('details_grid requires numeric "columns"');
      }
      if (!Array.isArray(block.rows)) {
        errors.push('details_grid requires an array of rows');
      }
      break;
    case 'data_table':
      if (!block.data_api && !block.data) {
        errors.push('data_table block requires either data_api or data field');
      }
      if (block.columns && !Array.isArray(block.columns)) {
        errors.push('data_table columns must be an array');
      }
      if (block.search && typeof block.search !== 'object') {
        errors.push('data_table search must be an object');
      }
      if (block.search && block.search.enabled && !block.search.query_param) {
        errors.push('data_table search requires query_param when enabled');
      }
      if (block.default_query_params && typeof block.default_query_params !== 'object') {
        errors.push('data_table default_query_params must be an object');
      }
      break;
      
    case 'button_list':
      if (!block.buttons || !Array.isArray(block.buttons)) {
        errors.push('button_list block requires buttons array');
      }
      break;
      
    case 'form':
      if (!block.fields || !Array.isArray(block.fields)) {
        errors.push('form block requires fields array');
      }
      break;
      
    case 'simple_table':
      if (!block.columns || !Array.isArray(block.columns)) {
        errors.push('simple_table block requires columns array');
      }
      if (!block.data_api && !block.data) {
        errors.push('simple_table block requires either data_api or data field');
      }
      break;
      
    case 'text':
    case 'markdown':
      if (!block.content && !block.text) {
        errors.push('text/markdown block requires content or text field');
      }
      break;
      
    case 'metric':
      if (block.value === undefined || block.value === null) {
        errors.push('metric block requires value field');
      }
      break;
      
    case 'pill_list':
      if (!block.pills || !Array.isArray(block.pills)) {
        errors.push('pill_list block requires pills array');
      }
      break;
      
    case 'card_collection':
      if (!block.cards || !Array.isArray(block.cards)) {
        errors.push('card_collection block requires cards array');
      }
      break;
      
    case 'collapsible':
    case 'accordion':
      if (!block.items || !Array.isArray(block.items)) {
        errors.push('collapsible/accordion block requires items array');
      }
      break;
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
}; 